import { render, staticRenderFns } from "./ConsultaIngreso.vue?vue&type=template&id=b603ef10"
import script from "./ConsultaIngreso.vue?vue&type=script&lang=js"
export * from "./ConsultaIngreso.vue?vue&type=script&lang=js"
import style0 from "./ConsultaIngreso.vue?vue&type=style&index=0&id=b603ef10&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports